"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsNativeError = void 0;
const getIsNativeError = (err) => {
    return (err instanceof Error &&
        'code' in err &&
        ('nativeStackIOS' in err || 'nativeStackAndroid' in err));
};
exports.getIsNativeError = getIsNativeError;
